import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/CampaignHashtagCloud.graphql';
import { Query, QuerycampaignHashtagCloudArgs } from '../../__generated__/globalTypes';

export const useCampaignHashtagCloudQuery = (options?: QueryHookOptions<Query, QuerycampaignHashtagCloudArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerycampaignHashtagCloudArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useCampaignHashtagCloudLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerycampaignHashtagCloudArgs>
): QueryResult<Query, QuerycampaignHashtagCloudArgs> & {
  getCampaignHashtagCloud: LazyQueryExecFunction<Query, QuerycampaignHashtagCloudArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getCampaignHashtagCloud, result] = useLazyQuery<Query, QuerycampaignHashtagCloudArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getCampaignHashtagCloud, ...result };
};

export const useCampaignHashtagCloudPromiseQuery = () => {
  const client = useApolloClient();

  const getCampaignHashtagCloud = useCallback(
    (options?: Omit<QueryOptions<QuerycampaignHashtagCloudArgs, Query>, 'query'>) =>
      client.query<Query, QuerycampaignHashtagCloudArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getCampaignHashtagCloud };
};
// Suspense Query Hooks
export const useCampaignHashtagCloudSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerycampaignHashtagCloudArgs>
) => {
  const result = useSuspenseQuery<Query, QuerycampaignHashtagCloudArgs>(QUERY, {
    ...options
  });

  return result;
};
